import React from "react";
import { useTranslation } from "react-i18next";

const Tip = () => {
  const { t } = useTranslation();

  return (
    <div className="tutorial_q_wrap">
      <div className="tutorial_q">
        <div className="tutorial_notes">
          <img className="q_img" src={ `${ process.env.PUBLIC_URL }/static/images/common/img_tutorial_problem.png`} alt="" />
          <img className="arr" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_ar_04.svg`} alt="" />
          <img className="arr_m" src={ `${ process.env.PUBLIC_URL }/static/images/common/ic_tutorial_mo_btm1-1.svg`} alt="" />
          <p className="tutor_txt" dangerouslySetInnerHTML={{ __html: t('LC_05_17.msg004') }}/>
        </div>
      </div>
    </div>
    // <div className="tutorial_q_wrap">
    //   <div className="tutorial_q">
    //     <img className="q_img" src={ `${ process.env.PUBLIC_URL }/static/images/common/img_tutorial_problem.png` } alt="" />
    //   </div>
    // </div>
  );

};

export default Tip;
